import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import axiosCall from '../../utils/services/interceptor';
import { Spin } from 'antd';

const SessionRedirect = () => {
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const verifyEmail = async () => {
      try {
        const baseUrl = process.env.REACT_APP_SERVER_URL || '';
        const url = `${baseUrl}/pds/auth/user/email/verify`;
        await axiosCall('get', url);
      } finally {
        setIsLoading(false);
        history.push('/');
      }
    }

    verifyEmail();
  }, [history]);

  if (isLoading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh'
      }}>
        <Spin size="large" />
      </div>
    );
  }

  return null;
};

export default SessionRedirect;
